import { useModalOpener } from "../../hooks/useModalOpener";
import PharmaStpFileTable from "./components/pharmaStpFileTable";

/**
 * NYCBS Delivery SFTP orders page rendered under `pharma-pa-sftp-file/sftp-file-orders`.
 */
const PharmaStpFile = () => {
  useModalOpener();

  return (
    <div className="pharma_stp_file__layout h-full w-full bg-primaryGray-16 p-2">
      <div className="pharma_stp_file__inner-container flex h-full flex-col gap-2 overflow-hidden rounded bg-white p-4">
        <div className="pharma_stp_file__heading text-h11 font-bold">
          SFTP Orders
        </div>
        <div className="pharma_stp_file__table-container flex-1 overflow-auto">
          <PharmaStpFileTable />
        </div>
      </div>
    </div>
  );
};

export default PharmaStpFile;
